import Button from '../../../components/ui/Button';

interface FormActionsProps {
  onSave: () => void;
  onSubmit: () => void;
  onCancel: () => void;
  isSaving: boolean;
  isSubmitting: boolean;
  hasProducts: boolean;
  isValid: boolean;
}

const FormActions = ({
  onSave,
  onSubmit,
  onCancel,
  isSaving,
  isSubmitting,
  hasProducts,
  isValid
}: FormActionsProps) => {
  return (
    <div className="flex items-center justify-between p-6 bg-card border-t border-border">
      <div className="flex items-center gap-2">
        <Button
          variant="outline"
          onClick={onCancel}
          disabled={isSubmitting || isSaving}
        >
          Cancelar
        </Button>
        
        <Button
          variant="secondary"
          onClick={onSave}
          loading={isSaving}
          disabled={isSubmitting || !hasProducts}
          iconName="Save"
          iconPosition="left"
        >
          Salvar Rascunho
        </Button>
      </div>

      <div className="flex items-center gap-4">
        <div className="text-sm text-muted-foreground">
          {!isValid && 'Preencha todos os campos obrigatórios'}
          {isValid && !hasProducts && 'Adicione pelo menos um produto'}
        </div>
        
        <Button
          variant="default"
          onClick={onSubmit}
          loading={isSubmitting}
          disabled={isSaving || !hasProducts || !isValid}
          iconName="Send"
          iconPosition="left"
          size="lg"
        >
          Enviar Consulta
        </Button>
      </div>
    </div>
  );
};

export default FormActions;